module.exports = __webpack_public_path__ + "img/escadaria_01.76367fbc.jpg";